import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/device',
    name: 'Device',
    component: () => import('@/views/device/DeviceView.vue')
  },
  {
    path: '/device/add',
    name: 'AddDevice',
    component: () => import('@/views/device/AddDeviceView.vue')
  },
  {
    path: '/device/timer',
    name: 'TimerSettings',
    component: () => import('@/views/device/TimerView.vue')
  },
  {
    path: '/community',
    name: 'Community',
    component: () => import('@/views/community/CommunityView.vue')
  },
  {
    path: '/device/sensor-chart',
    name: 'SensorChartView',
    component: () => import('@/views/device/SensorChartView.vue')
  },
  {
    path: '/community/post/:id',
    name: 'PostDetail',
    component: () => import('@/views/community/PostDetailView.vue')
  },
  {
    path: '/community/post/new',
    name: 'NewPost',
    component: () => import('@/views/community/NewPostView.vue')
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/views/mine/MineView.vue')
  },
  {
    path: '/mine/edit',
    name: 'EditProfile',
    component: () => import('@/views/mine/EditProfileView.vue')
  },
  {
    path: '/mine/posts',
    name: 'MyPosts',
    component: () => import('@/views/mine/MinePostsView.vue')
  },
  {
    path: '/mine/favorites',
    name: 'MyFavorites',
    component: () => import('@/views/mine/MineFavoritesView.vue')
  },
  {
    path: '/mine/likes',
    name: 'MyLikes',
    component: () => import('@/views/mine/MineLikesView.vue')
  },
  {
    path: '/mine/following',
    name: 'MyFollowing',
    component: () => import('@/views/mine/MineFollowingView.vue')
  },
  {
    path: '/mine/followers',
    name: 'MyFollowers',
    component: () => import('@/views/mine/MineFollowersView.vue')
  },
  {
    path: '/mine/others/:id',
    name: 'OtherProfile',
    component: () => import('@/views/mine/MineOthersView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Login.vue')
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// 全局前置守卫：检查登录状态
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.name !== 'Login' && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router;